<template>
    <div id="trunk">
        <lead :headOption="headOption"/>
        <main class="main">
            <router-view />
        </main>
        <foote/>
    </div>
</template>
<script>
import lead from "@/components/common/head";
import foote from "@/components/common/footer";
export default {
    data() {
        return {
       // 顶部模块标题：
            headOption: {
                link: "/teach",
                title: "名师中心"
            },
        };
    },
    created() { },
    mounted(){},
    methods: {},
    components: {
        lead,
        foote
    }
};
</script>
<style lang="scss">
.main {
    box-sizing: border-box;
    min-height: calc(100vh - 124px);
}
.course-menunav a {
    display: block;
    line-height: 65px;
}
 @import  './../../../assets/css/teach.scss'
</style>